import { ReactComponent as EditIcon } from "../assets/icons/edit.svg";
import { ReactComponent as RemoveIcon } from "../assets/icons/remove.svg";
import { ReactComponent as ValidationIcon } from "../assets/icons/validation.svg";
import { ReactComponent as AddIcon } from "../assets/icons/add.svg";
import { ReactComponent as DownloadIcon } from "../assets/icons/download-svgrepo-com.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/upload-svgrepo-com.svg";
import { JSX } from "react";
import "../stylesheets/editButton.scss";

// TYPES
type EditButtonProps = {
	variant: "edit" | "delete" | "add" | "send" | "download" | "upload";
	type: "button" | "submit" | "reset" | "file";
	form?: string;
	showText?: boolean;
	onClick?: (arg0: any) => void;
	onChange?: (arg0: React.ChangeEvent<HTMLInputElement>) => void;
};

// CONST
const ICON_MAP: Record<EditButtonProps["variant"], JSX.Element> = {
	send: <ValidationIcon />,
	edit: <EditIcon />,
	delete: <RemoveIcon />,
	add: <AddIcon />,
	download: <DownloadIcon />,
	upload: <UploadIcon />,
};

// COMPONENT
function EditButton({
	variant,
	onClick,
	onChange,
	type,
	form,
	showText = true,
}: EditButtonProps) {
	if (type === "file") {
		return (
			<label className={variant + " edit-button"}>
				{ICON_MAP[variant]}
				{showText && <span className="secondary-text">{variant}</span>}
				<input
					type="file"
					className="edit-button-file-input"
					onChange={onChange}
					form={form}
				/>
			</label>
		);
	}

	return (
		<button
			type={type}
			className={variant + " edit-button"}
			onClick={onClick}
			form={form}
		>
			{ICON_MAP[variant]}
			{showText && <span className="secondary-text">{variant}</span>}
		</button>
	);
}

export default EditButton;
